<template>
    <div class="dummyInput">
        <!--   输入设备    -->
        <div class="inputEquipment">
            <div class="clickContent" data-tag="clear" @click="hitEnter">
                <div class="inputTitle">
                    <span>修改价格</span>
                    <span>（原价：<i>￥20</i>）</span>
                </div>
                <div class="priceInput">
                    <input type="text" placeholder="输入结算价" />
                </div>
                <div class="inputContent">
                    <span data-number="1" data-tag="clear"><i data-number="1" data-tag="clear">1</i></span>
                    <span data-number="2" data-tag="clear"><i data-number="2" data-tag="clear">2</i></span>
                    <span data-number="3" data-tag="clear"><i data-number="3" data-tag="clear">3</i></span>
                    <span data-number="rollback" data-tag="clear"><i data-number="rollback" data-tag="clear" class="iconfont icon-zuojiantou"></i></span>
                    <span data-number="4" data-tag="clear"><i data-number="3" data-tag="clear">4</i></span>
                    <span data-number="5" data-tag="clear"><i data-number="5" data-tag="clear">5</i></span>
                    <span data-number="6" data-tag="clear"><i data-number="6" data-tag="clear">6</i></span>
                    <span data-number="clear" data-tag="clear"><i data-number="clear" data-tag="clear" class="iconfont icon-chacha"></i></span>
                    <span data-number="7" data-tag="clear"><i data-number="7" data-tag="clear">7</i></span>
                    <span data-number="8" data-tag="clear"><i data-number="8" data-tag="clear">8</i></span>
                    <span data-number="9" data-tag="clear"><i data-number="9" data-tag="clear">9</i></span>
                    <span data-number="return" data-tag="clear"><i data-number="return" data-tag="clear" class="iconfont icon-duihao"></i></span>
                    <span data-number="none" data-tag="clear" style="visibility: hidden"><i data-number="none" data-tag="clear"></i></span>
                    <span data-number="0" data-tag="clear"><i data-number="0" data-tag="clear">0</i></span>
                    <span data-number="none" data-tag="clear"><i data-tag="clear">.</i></span>
                    <span data-number="none" data-tag="clear" style="visibility: hidden"><i data-number="none" data-tag="clear"></i></span>
                </div>

                <div class="operatingButton">
                    <span>取消</span>
                    <span>确认</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'dummyInput',
    data() {
        return {
        }
    },
    methods: {
        // 输入监听
        hitEnter() {}
    }
}
</script>

<style lang="scss">
.dummyInput {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.3);
    z-index: 99999;

    .inputEquipment {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .clickContent {
            width: 500px;
            height: 550px;
            border-radius: 5px;
            background-color: #FFFFFF;

            .inputTitle {
                height: 50px;
                line-height: 50px;
                text-align: center;
                >span:first-child {
                    font-weight: bold;
                    font-size: 17px;
                }
                >span:last-child {
                    >i {
                        color: #d30505;
                        font-weight: bold;
                    }
                }
            }

            .priceInput {
                width: 320px;
                height: 40px;
                margin: 0 auto 10px;
                border: 2px solid #333333;
                input {
                    width: 100%;
                    height: 100%;
                    padding-left: 20px;
                    box-sizing: border-box;
                }
            }

            .inputContent {
                width: 320px;
                margin: 0 auto 0;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;

                >span {
                    width: 75px;
                    height: 75px;
                    line-height: 75px;
                    font-size: 0;
                    text-align: center;
                    margin-top: 10px;
                    border-radius: 50%;
                    border: 1px solid #999999;
                    cursor: pointer;
                    >i {
                        font-size: 18px;
                        vertical-align: middle;
                        user-select: none;
                        cursor: pointer;
                    }
                    &:active {
                        background-color: #2b89eb8f;
                        font-weight: bold;
                        color: #FFFFFF;
                    }
                }
            }

            .operatingButton {
                height: 55px;
                margin-top: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                >span {
                    width: 140px;
                    height: 45px;
                    line-height: 45px;
                    text-align: center;
                    margin: 0 20px;

                    &:first-child {
                        border: 1px solid #9d9d9d;
                        color: #333333;
                        font-size: 16px;
                        font-weight: bold;
                    }
                    &:last-child {
                        background-color: #7a7a7a;
                        color: #FFFFFF;
                        font-size: 16px;
                        font-weight: bold;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/paperless/components/dummyInput/index.vue